import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {Group} from 'domain/usecases';
import {useFilters} from '../../hooks';
import {SearchFilterHeaderProps} from './types';

const {searchProcedure, serviceType} = translations['pt-br'].privateFlow.franchisesTable;
const {filter, all} = translations['pt-br'].commons;

export function SearchFilterHeader({
	otherData,
	debouncedQueryFunc,
	abortDebounce,
	clearSearchParams,
}: SearchFilterHeaderProps) {
	const {
		handleConfirmShift,
		handleClearFilters,
		handleOpenDrawer,
		handleCloseDrawer,
		openDrawerState,
		shift,
		searchValueState,
		filterValueState,
		setFilterValueState,
	} = useFilters();

	const handleGetAllCategoryList = () => [
		{
			categoryTitle: serviceType,
			categoryItemsList: [
				{
					active: !filterValueState,
					title: all,
					onClick: () => setFilterValueState(''),
				},
				...(otherData?.groups?.map((group: Group) => ({
					active: filterValueState === group.cdGrupo,
					title: group.dsGrupo,
					onClick: () => setFilterValueState(group.cdGrupo),
				})) || []),
			],
		},
	];

	return (
		<Filter.Root sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1}}>
			<Filter.Search
				handleChange={() => {
					abortDebounce();
					debouncedQueryFunc();
				}}
				clearSearch={clearSearchParams}
				placeholder={searchProcedure}
				value={searchValueState}
			/>
			<Filter.Button onClick={handleOpenDrawer} count={shift ? 1 : 0}>
				{filter}
			</Filter.Button>
			<Drawer.Root
				open={openDrawerState}
				onOpen={handleOpenDrawer}
				onClose={handleCloseDrawer}>
				<Drawer.Header title={filter} onClose={handleCloseDrawer} />
				<Drawer.ContentListByCategory categoryList={handleGetAllCategoryList()} />
				<Drawer.Footer
					firstButtonOnClick={handleClearFilters}
					secondButtonOnClick={() => {
						handleConfirmShift();
					}}
				/>
			</Drawer.Root>
		</Filter.Root>
	);
}
